const locale = process.browser ? window.navigator.language : 'fr';

const meta = {
  openGraph: {
    type: 'website',
    locale: locale,
    url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}`,
    site_name: 'Finary',
    images: [
      {
        //TODO: fix German translation
        url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/meta/${
          locale === 'de' ? 'en' : locale
        }/sharing.png`,
        width: 1200,
        height: 640,
        alt: "Votre patrimoine en clin d'oeil",
      },
    ],
  },
  twitter: {
    handle: '@finaryhq',
    site: '@finaryhq',
    cardType: 'summary_large_image',
  },
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
    },
    {
      name: 'mobile-web-app-capable',
      content: 'yes',
    },
    {
      name: 'apple-mobile-web-app-capable',
      content: 'yes',
    },
    {
      name: 'application-name',
      content: 'Finary',
    },
    {
      name: 'theme-color',
      content: '#000000',
    },
    {
      name: 'msapplication-navbutton-color',
      content: '#000000',
    },
    {
      name: 'apple-itunes-app',
      content: 'app-id=1569413444',
    },
  ],
};

export default meta;
